import React from "react";

import { useGlobalContext } from "shared/utils/hooks/useGlobalContext";

export const LogoutIcon = () => {
  const {
    state: { theme },
  } = useGlobalContext();
  const isDarkMode = theme.value === "dark";

  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.49805 15.7498V14.2498L2.99805 14.2496V3.62568C2.99805 3.26321 3.25726 2.95262 3.61388 2.88778L10.7175 1.5962C10.962 1.55174 11.1963 1.71392 11.2408 1.95845C11.2456 1.985 11.248 2.01195 11.248 2.03894V2.99962L14.248 2.99975C14.6622 2.99975 14.998 3.33554 14.998 3.74975V14.2496L16.498 14.2498V15.7498H13.498V4.49975L11.248 4.49962V15.7498H1.49805ZM8.99801 8.24977H7.49805V9.74977H8.99801V8.24977Z"
        fill={isDarkMode ? "#F2F2F2" : "#050505bf"}
      />
    </svg>
  );
};
